import type { VerbTypes } from 'modules/core/lib/verbTypes'

import Policy from './Policy'

class PermissionGroupPolicy extends Policy<VerbTypes> {
  checkVerb(verb: VerbTypes): boolean {
    switch (verb) {
      // Both are present in the UserPolicy also
      case 'permissions.groupCreate':
        return this.permissions.permissions_groups.create

      case 'permissions.groupEdit':
        return this.permissions.permissions_groups.edit

      case 'permissions.groupAssignEmployees':
        return this.permissions.permissions_groups.assign_employees

      case 'permissions.groupCreateExternalUsers':
        return this.permissions.permissions_groups.create_external_users

      case 'permissions.editExternalUsers':
        return this.permissions.permissions_groups.edit_external_users

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
    }
  }
}

export default PermissionGroupPolicy
